import { selectBillingAddressModel } from './CustomerDetails';
import util from '../lib/util';

export const selectAllNewContacts = (state) => {
    const f = state.form;
    let contacts = [];
    let temp = null;
    if (state.gas.user && state.gas.user.bpNumber) {
        if (!state.form.secondAccountContactSaved) {
            temp = getContact(state, "secondAccountContact");
            if (temp)
                contacts.push(temp);
        }
        if (f.customerType != "1") {
            const ids = state.form.moreContactPersonIds || [];
            for (let i = 0; i < ids.length; i++) {
                if (!state.form[`aditionalContactPerson${ids[i]}Saved`]) {
                    temp = getContact(state, `aditionalContactPerson${ids[i]}`);
                    if (temp)
                        contacts.push(temp);
                }
            }
        }
        else {
            if (!state.form.emergencyContactSaved) {
                temp = getEmergencyContact(state);
                if (temp)
                    contacts.push(temp);
            }
        }
    }
    return contacts;
};

const getContact = (state, name) => {
    const f = state.form;
    const firstName = f[`${name}FirstName`];
    const lastName = f[`${name}LastName`];
    if (!firstName && !lastName)
        return null;
    let toRet = {
        name,
        bpNumber: state.gas.user && state.gas.user.bpNumber,
        isBusiness: f.customerType != "1",
        isBuilder: f.customerType == "3",
        address: { ...selectBillingAddressModel(state, `${name}Address`) },
        firstName,
        lastName,
    };
    //isBusiness
    if (f.customerType != "1") {
        toRet.primaryPhone = f[`${name}PrimaryPhone`];
        toRet.primaryPhoneExt = f[`${name}PrimaryPhone_ext`];
    }
    else {
        toRet.DOB = util.DobFormatter(f[`${name}DOB`]);
    }
    return toRet;
};
const getEmergencyContact = (state) => {
    const f = state.form;
    const firstName = f.emergencyContactFirstName;
    const lastName = f.emergencyContactLastName;
    if (!firstName && !lastName)
        return null;
    let toRet = {
        name: "emergencyContact",
        bpNumber: state.gas.user && state.gas.user.bpNumber,
        isBusiness: f.customerType != "1",
        isBuilder: f.customerType == "3",
        EmergencyContact:
        {
            firstName,
            lastName,
            primaryPhone: f.emergencyContactPrimaryPhone,
            PrimaryPhoneExt: f.emergencyContactPrimaryPhone_ext
        }
    };
    return toRet;
};
